module.exports = __webpack_public_path__ + "media/images/png/search-1566a5fe2c38368d025ec516895d1b99.png";